var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('van-button',{class:[_vm.canClick ? 'btn-active' : '', 'btn-photo'],attrs:{"disabled":!_vm.canClick,"loading":_vm.loading,"loading-text":"Siguiente","loading-type":"spinner"},on:{"click":_vm.submit}},[_vm._v("Siguiente")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }